export enum LINKTypeEnum {
  NONE,
  CONTESTID,
  LINK,
}

export const LINKTypeMap = new Map([
  [LINKTypeEnum.NONE, '无'],
  [LINKTypeEnum.CONTESTID, 'contest详情'],
  [LINKTypeEnum.LINK, '链接（比赛结果落地页）'],
]);
